import L from 'leaflet';
import MapPin from './_MapPin';
import { MAP_MIN_ZOOM } from '../map/MapConstants';

// External configuration
const config = 
{
	defaultIconSize: 25,
	iconZoomMultiplier: 1.25 * 1.03,
	textXOffset: 2,
	textTopYOffset: -4,
	textBottomYOffset: -4,
	textLRYOffset: -4,
	pinTipHeight: 6,
};

export default class SiteMapPin extends MapPin
{
	constructor(id, latlng, texts, lang = 'ja', options = {})
	{
		options = 
		{
			...config,
			...options
		};

		super(id, latlng, texts, lang, options);
	}

	initVars(options = {})
	{
		this._markerClassName = 'site';
		this._tooltipClassName = 'site';

		this._zone = options.zone;
		this._zoneID = options.zoneID;
		this._zoneSiteID = options.zoneSiteID;
		this._isConstruction = options.isConstruction || false;

		this._tooltipDirection = options.tooltipDirection;
	}

	updateTooltipPosition() 
	{
		const tooltipOptions = this.getTooltipOptions();

		this.setTooltipOptions(tooltipOptions);
	}

	getTooltipOptions() 
	{
		const mult = Math.pow(config.iconZoomMultiplier, this._zoomLevel - MAP_MIN_ZOOM);

		const iconSize = config.defaultIconSize * mult;

		const tty = config.textTopYOffset * mult;
		const tlry = config.textLRYOffset;

		const tipHeight = config.pinTipHeight;

		let tooltipDirection = this._tooltipDirection || 'right';
		let tooltipOffset = L.point(0, 0);

		const tx = iconSize * 0.5 + config.textXOffset;
		const ty1 = -iconSize * 0.5 - tipHeight + tlry;
		const ty2 = -iconSize - tipHeight + tty;
		const ty3 = config.textBottomYOffset;

		switch (tooltipDirection) 
		{
			case 'left':
				tooltipOffset = L.point(-tx, ty1);
				break;
			case 'right':
				tooltipOffset = L.point(tx, ty1);
				break;
			case 'top':
				tooltipOffset = L.point(0, ty2);
				break;
			case 'bottom':
				tooltipOffset = L.point(0, ty3);
				break;
			default:
				tooltipOffset = L.point(tx, ty1); // Default to right
				break;
		}

		// Tooltip options
		const tooltipOptions = 
		{
			className: ['map-pin', this._tooltipClassName].join(' '),
			direction: tooltipDirection,
			offset: tooltipOffset,
			permanent: true
		};

		return tooltipOptions;
	}

	setTooltipOptions(tooltipOptions)
	{
		const tooltip = this.getTooltip();
		if (tooltip)
		{
			tooltip.options = { ...tooltip.options, ...tooltipOptions };
			tooltip.update();
		}
	}

	createIcon(options = {})
	{
		return L.divIcon(
		{
			className: ['map-pin', this._markerClassName].join(' '),
			html: this.makeHTML(options),
			iconSize: [this._iconsize, this._iconsize]
		});
	}

	makeHTML(options = {})
	{
		const img = options.img || '';

		let html = `
		<div class="pin-scale">
			<div class="pin-inner">
			<div class="site-image" style="background-image:url('${img}')"></div>
			${this._isConstruction ? `
			<div class="notification-icon under-construction">
				<div class="icon">
					<p class="icon construction"></p>
				</div>
			</div>
			` : ''}
			</div>
		</div>
		`;

		return html;
	}

	updateDataAttribute()
	{
		const element = this.getElement();
		if (element)
		{
			element.setAttribute('data-zone', this._zone);
			element.setAttribute('data-zone-id', this._zoneID);
		}

		this.updateTooltipMinZoom();
	}

	handleUpdateZoom()
	{
		this.updateTooltipPosition();
	}
}
